<div class="input-container">
    <label *ngIf="label">{{ label }}</label>
    <input [type]="type" [value]="value" [placeholder]="placeholder" [disabled]="disabled" (blur)="onTouched()" />
</div>
